import { mapActions, mapState } from 'vuex';

export default {
  data() {
    return {
      cardinalSetup: false,
      encryptedCard: null,
      checkoutUrl: null,
    };
  },

  computed: {
    ...mapState('application', ['canInteract']),
  },

  methods: {
    ...mapActions('payment', [
      'postPayment',
      'verifoneInit',
      'verifone3dSecure',
      'verifonePostPayment',
    ]),

    async processVerifoneCheckout() {
      try {
        const response = await this.postPayment({
          orderUuid: this.previousOrder.uuid,
          paymentMethodId: this.paymentMethod.id,
        });

        this.checkoutUrl = response.data.url;
      }
      catch (e) {
        this.showErrorDialog(e);
        this.allowInteraction();
        clearInterval(this.paymentCheckInterval);
      }
    },

    async processVerifonePayment() {
      if (!window.verifone || !window.Cardinal) {
        this.$q.dialog({
          title: 'Missing Verifone scripts',
        });
      }
      else {
        // Initialize 3d secure checks
        let threedsLookupData = null;
        const initResponse = await this.verifoneInit({ paymentMethodId: this.paymentMethod.id });

        if (initResponse.data.public_key) {
          this.encryptedCard = await window.verifone.encryptCard({
            cardNumber: this.paymentData.cardNumber,
            expiryMonth: this.paymentData.expiration.slice(2, 4),
            expiryYear: this.paymentData.expiration.slice(0, 2),
            cvv: this.paymentData.ccv,
          }, initResponse.data.public_key);

          window.Cardinal.configure({
            timeout: 8000,
            maxRequestRetries: 2,
            payment: {
              view: 'modal',
              framework: 'cardinal',
              displayLoading: true,
            },
          });

          if (!this.cardinalSetup) {
            window.Cardinal.on('payments.setupComplete', async (setupCompleteData) => {
              const threedsResponse = await this.verifone3dSecure({
                sessionId: setupCompleteData.sessionId,
                paymentMethodId: this.paymentMethod.id,
                orderUuid: this.previousOrder.uuid,
                publicKeyAlias: initResponse.data.public_key_alias,
                encryptedCard: this.encryptedCard,
              });

              threedsLookupData = threedsResponse.data;
              if (!threedsLookupData.acs_url) {
                // No 3dsecure required, continue to payment.
                try {
                  await this.verifonePostPayment({
                    orderUuid: this.previousOrder.uuid,
                    paymentMethodId: this.paymentMethod.id,
                    paymentData: this.paymentData,
                    publicKeyAlias: initResponse.data.public_key_alias,
                    encryptedCard: this.encryptedCard,
                    threedsLookupData,
                    jwt: null,
                  });
                  return;
                }
                catch (e) {
                  this.showErrorDialog(e);
                  this.allowInteraction();
                  clearInterval(this.paymentCheckInterval);
                }
              }
              else {
                window.Cardinal.continue('cca',
                  {
                    AcsUrl: threedsLookupData.acs_url,
                    Payload: threedsLookupData.payload,
                  },
                  {
                    OrderDetails: { TransactionId: threedsLookupData.transaction_id },
                  });
              }
            });

            window.Cardinal.on('payments.validated', async (decodedResponseData, jwt) => {
              if (decodedResponseData.ActionCode === 'SUCCESS') {
                try {
                  await this.verifonePostPayment({
                    orderUuid: this.previousOrder.uuid,
                    paymentMethodId: this.paymentMethod.id,
                    paymentData: this.paymentData,
                    publicKeyAlias: initResponse.data.public_key_alias,
                    encryptedCard: this.encryptedCard,
                    jwt,
                    threedsLookupData,
                  });
                }
                catch (e) {
                  this.showErrorDialog(e);
                  this.allowInteraction();
                  clearInterval(this.paymentCheckInterval);
                }
              }
              else {
                this.$q.dialog({
                  message: decodedResponseData.ErrorDescription,
                });
                this.allowInteraction();
                clearInterval(this.paymentCheckInterval);
              }
            });

            this.cardinalSetup = true;
          }

          window.Cardinal.setup('init', {
            jwt: initResponse.data.jwt,
          });
        }
      }
    },
  },
};
